module.exports = __webpack_public_path__ + "img/graphics-no-results-happy.ecec5a7f.svg";